module.exports = __webpack_public_path__ + "static/media/technology-cover-Tablet.6565c32b.png";